const formatContact = (person) => {
  // name
  let fullName = [person?.first_name, person?.middle_name, person?.last_name].filter(item => item && item.length > 0).join(" ").trim()
  // name and degree
  let fullNameDegree = [fullName, person?.degrees].filter(item => item && item.length > 0).join(", ").trim();
  // phone and ext
  let phoneNumber = [person?.phone, person?.phone_ext].filter(item => item && item.toString().length > 0).join(" ext: ").trim()

  return [fullNameDegree, phoneNumber, person?.email].filter(str => str && str.length > 0).join(", ");
}

export {
  formatContact,
}